<template>
<ValidationObserver tag="div" class="col" ref="form" v-slot="{ handleSubmit, invalid }">
    <Loading />
    <Message />

    <CForm method="post" @submit.prevent="handleSubmit(submit)">
        <CRow>
            <CCustomInput
                v-if="isActiveInput(CPA, CPO, CPL) && commission.name !== 'default'"
                v-model="commission.name"
                :name="$t('commission.name')"
                col="12"
                required
                :rules="{required: true, excluded: excludedNames}"
                vid="name"
                ltr
                :description="$t('commission.name_rule')"
            />

            <CCustomInput
                v-if="isActiveInput(CPA, CPO, CPL) && commission.name !== 'default'"
                v-model="commission.display_name"
                :name="$t('commission.display_name')"
                col="12"
                required
                rules="required"
                vid="display_name"
            />

            <CCustomInput
                v-model="commission.benefit"
                :name="$t('commission._')+'('+(commission.type === AMOUNT ? $t('rial') : $t('percent'))+')'"
                col="12"
                required
                rules="required"
                vid="benefit"
                ltr
            />

            <CCustomInput
                v-if="commission.type === PERCENT"
                v-model="commission.limit"
                :name="$t('commission.limit')+'('+$t('rial')+')'"
                col="12"
                vid="limit"
                :rules="{numeric: true}"
                ltr
            />

            <!-- <CCol sm="12">
                <ValidationProvider tag="div" vid="description" :name="$t('commission.description')" v-slot="{ errors }">
                    <CTextarea v-model="commission.description">
                        <template #label>{{ $t('commission.description') }}</template>
                        <template #invalid-feedback><span class="invalid-feedback d-block">{{ errors[0] }}</span></template>
                    </CTextarea>
                </ValidationProvider>
            </CCol> -->

            <CCustomSelect
                sm="12" md="4"
                v-model="commission.status"
                :options="statuses"
                vid="status"
                required
                rules="required"
                :name="$t('commission.status')"
            />

            <CCustomSearchableInput
                v-if="!commission.id"
                col="12" md="6"
                vid="store_id"
                :name="$t('store._')"
                v-model="storeId"
                required
                rules="required"
                :items="selectableStores"
            />
        </CRow>
        <CButton :disabled="invalid" type="submit" color="primary" class="px-4">{{ $t('submit') }}</CButton>
    </CForm>
</ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex'
import { CommissionConversionType } from '@/constants'
import { CCustomSelect } from '@/components/form'

export default {
    name: 'Form',
    components: {
        CCustomSelect,
    },

    props: {
        commission: {
            required: true,
        },
        submit: {
            default: function () {},
            type: Function
        },
    },

    data() {
        return {
            PERCENT: 0,
            AMOUNT: 1,

            storeId: '',

            ...CommissionConversionType,
            statuses: [
                {
                    label: this.$t('commission.statuses.active'),
                    value: 0
                },
                {
                    label: this.$t('commission.statuses.disable'),
                    value: 1
                },
            ],
            showLoading: false,

            errMessage: ''
        }
    },

    computed: {
        ...mapGetters('store', [
            'selectableStores'
        ]),
        excludedNames() {
            return ['click']
        }
    },

    watch: {
        'commission.limit': function(newVal) {
            this.commission.unlimited = newVal ? false : true
        },
        storeId(val) {
            this.commission.store_id = val.value
        }
    },

    methods: {
        updateCommissionType(commissionType) {
            this.commission.type = parseInt(commissionType)
        },
        updateConversionType(conversionType) {
            this.commission.conversion_type = parseInt(conversionType)
        },
        checkedUnlimited(isChecked) {
            this.commission.limit = isChecked ? null : this.commission.limit
        },
        isActiveInput() {
            return this.commission ? Array.from(arguments).includes(this.commission.conversion_type) : false
        }
    }
}
</script>
